import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import { deletedRestoreTerms, deletedTerm, setTerms, setTermsRestore, updateTerm } from "./academicTermsSlice";
import { ITermsCreate, ITermsPayload } from "../types";
import { IErrorResponse, IRootState } from "../../../../types";

const GetTerms = createAsyncThunk("get/academic/terms", async (_, { dispatch, rejectWithValue, getState }) => {
    try {
        const response = await request.get("/academic-terms");
        const lang = getState() as IRootState;
        const defaultLanguage = lang.languages.defaultLanguage;
        dispatch(setTerms({ data: response.data, defaultLanguage }));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const SetTerms = createAsyncThunk("set/academic/terms", async (data: ITermsCreate, { rejectWithValue }) => {
    try {
        const response = await request.post("/academic-terms", data);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteTerm = createAsyncThunk("delete/academic/term", async (id: number, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.delete(`/academic-terms/${id}`);

        dispatch(deletedTerm(id));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const GetDeleteTerms = createAsyncThunk("get/delete/terms", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/academic-terms/deleted-items`);

        dispatch(setTermsRestore(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteTerms = createAsyncThunk(
    "restore/delete/terms",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/academic-terms/restore/${id}`);

            dispatch(deletedRestoreTerms(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditTerm = createAsyncThunk("edit/academic/term", async (data: ITermsPayload, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.put(`/academic-terms/${data.id}`, data);
        dispatch(updateTerm(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});
export { GetTerms, SetTerms, DeleteTerm, EditTerm, GetDeleteTerms, RestoreDeleteTerms };
